module.exports = __webpack_public_path__ + "a4802bfec8610e0d272ac708a529b35e.png";